import { Component, inject, Input } from '@angular/core';
import { Invoice, InvoiceResponseModel } from '../../models/event.model';
import { EventViewModel } from '../../models-views/event.view.model';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
 interface IModalData {
  id: number;
  name: string;
}

@Component({
  selector: 'app-cet-invoice-details',
  standalone: false,
  templateUrl: './cet-invoice-details.component.html',
  styleUrl: './cet-invoice-details.component.scss'
})
export class CetInvoiceDetailsComponent {
  modalData?: IModalData;
  invoice:any
  invoiceDetailsResponseModel = new BehaviorSubject<InvoiceResponseModel>(new InvoiceResponseModel())
  loading:boolean = true
  constructor(private vm: EventViewModel,private modalRef: NzModalRef,private http: HttpClient){
    this.modalData = inject(NZ_MODAL_DATA); // Moved here
    this.vm.cetInvoiceDetailsComponent = this
    this.vm.subscribeToInvoiceDetails(this.invoiceDetailsResponseModel)
    
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // console.log(this.modalData.id)
   this.modalData.id && this.vm.getInvoiceDetails(this.modalData.id)
  }
  
  getStatusTagColor(status: string): string {
    switch (status?.toLowerCase()) {
      case 'paid': return 'green';
      case 'pending': return 'gold';
      case 'overdue': return 'red';
      default: return 'default';
    }
  }

  invoiceDetailsRecieved(){
    this.invoice = this.vm.invoiceDetailsResponseModel.value
    this.loading = false
  }

  getFileName(file_url:string): string {
    return file_url.split('/').pop()?.split('?')[0] || '';
  }

  // handleDownload(url: string, fileName: string) {

  //   console.log("url =====================",url);
  //   console.log("fileName =====================",fileName);

  //   return;

  //   if (url && !url.startsWith('http')) {
  //     url = `${environment.api_url}${url}`;
  //   }
  //   const link = document.createElement('a');
  //   link.target = '_blank';
  //   link.href = url;
  //   link.download = fileName || 'download';
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // }

  // -- new logic implemented using blob to download file for different end point and cors issue -- //

  handleDownload(url: string, fileName: string) {
  console.log('Original URL:', url, 'fileName:', fileName);

  if (url && !url.startsWith('http')) {
    url = `${environment.api_url}${url}`;
  }


  this.http.get(url, { responseType: 'blob' }).subscribe({
    next: (blob) => {
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    },
    error: (err) => {
      console.error('Download failed:', err);
    }
  });
}

  close(): void {
    this.modalRef.close(false);
  }
}
